import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  adminUnits: [],
  adminUnitTree: [],
  currentAdminUnit: null,
  isLoading: false,
  error: null,
};

const adminUnitSlice = createSlice({
  name: 'adminUnit',
  initialState,
  reducers: {
    fetchAdminUnitsStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchAdminUnitsSuccess: (state, action) => {
      state.isLoading = false;
      state.adminUnits = action.payload;
    },
    fetchAdminUnitTreeSuccess: (state, action) => {
      state.isLoading = false;
      state.adminUnitTree = action.payload;
    },
    fetchAdminUnitsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setCurrentAdminUnit: (state, action) => {
      state.currentAdminUnit = action.payload;
    },
    clearCurrentAdminUnit: (state) => {
      state.currentAdminUnit = null;
    },
  },
});

export const {
  fetchAdminUnitsStart,
  fetchAdminUnitsSuccess,
  fetchAdminUnitTreeSuccess,
  fetchAdminUnitsFailure,
  setCurrentAdminUnit,
  clearCurrentAdminUnit,
} = adminUnitSlice.actions;

export default adminUnitSlice.reducer;